// Copyright (c) 2022 Siemens

/**
 * @module js/oPINRuntimeModulePrereq
 */
import _appCtxSvc from 'js/appCtxService';
import cfgSvc from 'js/configurationService';
import _ from 'lodash';
import localeService from 'js/localeService';
import oPINRQCNavigationParamService from 'js/oPINRQuickComposerModule/oPINRQCNavigationParamService';
import utilService from 'js/commonUtilsModule/utilService';
import oPINRQuickComposerService from 'js/oPINRQuickComposerModule/oPINRQuickComposerService';
import oPINRQuickComposerModulePrereq from 'js/oPINRQuickComposerModulePrereq';
import oPINRQCService from 'js/oPINRuntimeModule/oPINRQCService';
import apmRESTService from 'js/commonUtilsModule/apmRESTService';
const exports = {};

function changePrereqStatus(howMuch = 0) {
    let reqS = _appCtxSvc.getCtx("prereqState") || 0;
    reqS += howMuch;
    _appCtxSvc.updateCtx("prereqState", reqS)
}
function checkFeatures(){
    const fList = _appCtxSvc.getCtx('FeaturesListNames');
    return (fList.indexOf("AssetPerformance") !== -1)
}
exports.assetPerformanceFeatureCheck = function(){
    if (!checkFeatures()){
        //momUtils.navigateTo("missingPage",null)
        alert("AssetPerformance feature not available")
        return Promise.reject("AssetPerformance feature not available")
    }
    checkNavParList();
    oPINRQuickComposerService.startCtxParamEngine();
    
    const storeLocalOffset = _appCtxSvc.getCtx("storeLocalOffset");
    if (storeLocalOffset === null || storeLocalOffset === undefined) {
        var locaTOffsetMS2 = new Date();
        var of = locaTOffsetMS2.getTimezoneOffset() * 60 * 1000;
        _appCtxSvc.updateCtx("storeLocalOffset",of);
    }
    
    const currentRuntimegPrj = _appCtxSvc.getCtx("currentRuntimegPrj");
    let p2 = Promise.resolve()
    if (currentRuntimegPrj === null || currentRuntimegPrj === undefined){
        const apiProject = _appCtxSvc.getCtx("oPINProjectsConfig").oPINRuntime.api;
        //"ctx.oPINProjectsConfig.oPINEngineering.apiProject + 'projects/' + stateParams.engprojectid"
        var projectK = _appCtxSvc.getCtx("state").processed.engprojectid;

        //p2 = utilService.OCINRESTService("get",apiProject+ 'runtime/projects/').then(p =>{
        p2 = apmRESTService.OCINRESTServiceValidated("get",apiProject+ 'runtime/projects/').then(p =>{
            _appCtxSvc.updateCtx("currentRuntimegPrj",p.data.search[0])
        })
    }
    const p1 = oPINRQuickComposerModulePrereq.initTradConf()
    return Promise.all([p1,p2]);
}
function checkNavParList(){
    //Navigation service prereq
    const navParsList = _appCtxSvc.getCtx("navParsList");
    if (navParsList === null || navParsList === undefined) {
        _appCtxSvc.updateCtx("navParsList", [{
                Id: 1,
                Name: "siteKey",
                Description: "Navigation site Key/Unique Identifier",
                Types: ['siteKey', 'string'],
                builtIn: true,
                paramName: "siteKey",
                DefaultValue: null
            },
            {
                Id: 2,
                Name: "assetKey",
                Description: "Navigation asset Key",
                Types: ["assetKey", "string"],
                builtIn: true,
                paramName: "assetKey",
                DefaultValue: null
            },
            {
                Id: 3,
                Name: "assetUID",
                Description: "Navigation asset Unique Identifier",
                Types: ['assetUID', 'object'],
                builtIn: true,
                paramName: "assetUID",
                DefaultValue: null
            }
        ]);
        oPINRQCNavigationParamService.getCurrentNavParams(); //ensure navigation start    
    }
}
function buildvalipPageTemplate() {
    const composerEmptyPage = _appCtxSvc.getCtx("composerEmptyPage");
    if (composerEmptyPage === null || composerEmptyPage === undefined) {
        var Page = {
            'composerVer': oPINRQuickComposerService.qcDashboardVersion,
            'root': {},
            'timeframes': []
        };
        Page.timeframes = _appCtxSvc.getCtx("OpcenterDashboardbComposerTimeframes");;
        var pageBlob = JSON.stringify(Page);
        _appCtxSvc.updateCtx("composerEmptyPage", pageBlob)
        return Promise.resolve({
            data: pageBlob
        });
    }
    return Promise.resolve(composerEmptyPage);
}
function moveTimeFrameToCtx() {
    const opTF = _appCtxSvc.getCtx("OpcenterDashboardbComposerTimeframes")
    const dopTF = _appCtxSvc.getCtx("defaultOpcenterDashboardbComposerTimeframes")
    if (opTF === null || opTF === undefined || dopTF === null || dopTF === undefined) {
        const TT = {
            "Previous_minute": "commonUtilsMessages",
            "Previous_minuteD": "commonUtilsMessages",
            "This_minute": "commonUtilsMessages",
            "This_minuteD": "commonUtilsMessages",
            "Minute_to_now": "commonUtilsMessages",
            "Minute_to_nowD": "commonUtilsMessages",
            "Last_minute": "commonUtilsMessages",
            "Last_minuteD": "commonUtilsMessages",
            "Previous_hour": "commonUtilsMessages",
            "Previous_hourD": "commonUtilsMessages",
            "This_hour": "commonUtilsMessages",
            "This_hourD": "commonUtilsMessages",
            "Hour_to_now": "commonUtilsMessages",
            "Hour_to_nowD": "commonUtilsMessages",
            "Last_hour": "commonUtilsMessages",
            "Last_hourD": "commonUtilsMessages",
            "Previous_day": "commonUtilsMessages",
            "Previous_dayD": "commonUtilsMessages",
            "This_day": "commonUtilsMessages",
            "This_dayD": "commonUtilsMessages",
            "Day_to_now": "commonUtilsMessages",
            "Day_to_nowD": "commonUtilsMessages",
            "Last_day": "commonUtilsMessages",
            "Last_dayD": "commonUtilsMessages",
            "Previous_week": "commonUtilsMessages",
            "Previous_weekD": "commonUtilsMessages",
            "This_week": "commonUtilsMessages",
            "This_weekD": "commonUtilsMessages",
            "Week_to_now": "commonUtilsMessages",
            "Week_to_nowD": "commonUtilsMessages",
            "Last_week": "commonUtilsMessages",
            "Last_weekD": "commonUtilsMessages",
            "This_shift": "commonUtilsMessages",
            "This_shiftD": "commonUtilsMessages",
            "Shift_to_now": "commonUtilsMessages",
            "Shift_to_nowD": "commonUtilsMessages",
            "This_workDay": "commonUtilsMessages",
            "This_workDayD": "commonUtilsMessages",
            "WorkDay_to_now": "commonUtilsMessages",
            "WorkDay_to_nowD": "commonUtilsMessages",
            "This_workWeek": "commonUtilsMessages",
            "This_workWeekD": "commonUtilsMessages",
            "WorkWeek_to_now": "commonUtilsMessages",
            "WorkWeek_to_nowD": "commonUtilsMessages"
        };
        let TTTrad = Object.getOwnPropertyNames(TT).map(x => {
            return localeService.getLocalizedText(TT[x], x)
        });
        const tf = [{
                "name": "Previous_minute",
                "description": "Previous_minuteD",
                "tfId": "previousMinute",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "minutesID",
                "periodMode": "previousID",
                "lastN": 1
            },
            {
                "name": "This_minute",
                "description": "This_minuteD",
                "tfId": "thisMinute",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "minutesID",
                "periodMode": "thisID",
                "lastN": 1
            }, {
                "name": "Minute_to_now",
                "description": "Minute_to_nowD",
                "tfId": "minuteToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "minutesID",
                "periodMode": "toNowID",
                "lastN": 1
            },
            {
                "name": "Last_minute",
                "description": "Last_minuteD",
                "tfId": "last1Minute",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "minutesID",
                "periodMode": "lastNID",
                "lastN": 1
            },
            {
                "name": "Previous_hour",
                "description": "Previous_hourD",
                "tfId": "previousHour",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "hoursID",
                "periodMode": "previousID",
                "lastN": 1
            },
            {
                "name": "This_hour",
                "description": "This_hourD",
                "tfId": "thisHour",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "hoursID",
                "periodMode": "thisID",
                "lastN": 1
            },
            {
                "name": "Hour_to_now",
                "description": "Hour_to_nowD",
                "tfId": "hourToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "hoursID",
                "periodMode": "toNowID",
                "lastN": 1
            },
            {
                "name": "Last_hour",
                "description": "Last_hour",
                "tfId": "last1Hour",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "hoursID",
                "periodMode": "lastNID",
                "lastN": 1
            },
            {
                "name": "Previous_day",
                "description": "Previous_dayD",
                "tfId": "previousDay",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "daysID",
                "periodMode": "previousID",
                "lastN": 1
            },
            {
                "name": "This_day",
                "description": "This_dayD",
                "tfId": "thisDay",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "daysID",
                "periodMode": "thisID",
                "lastN": 1
            },
            {
                "name": "Day_to_now",
                "description": "Day_to_nowD",
                "tfId": "dayToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "daysID",
                "periodMode": "toNowID",
                "lastN": 1
            },
            {
                "name": "Last_day",
                "description": "Last_dayD",
                "tfId": "last1Day",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "daysID",
                "periodMode": "lastNID",
                "lastN": 1
            },
            {
                "name": "Previous_week",
                "description": "Previous_weekD",
                "tfId": "previousWeek",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "weeksID",
                "periodMode": "previousID",
                "lastN": 1
            },
            {
                "name": "This_week",
                "description": "This_weekD",
                "tfId": "thisWeek",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "weeksID",
                "periodMode": "thisID",
                "lastN": 1
            },
            {
                "name": "Week_to_now",
                "description": "Week_to_nowD",
                "tfId": "weekToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "weeksID",
                "periodMode": "toNowID",
                "lastN": 1
            },
            {
                "name": "Last_week",
                "description": "Last_weekD",
                "tfId": "last1Week",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "weeksID",
                "periodMode": "lastNID",
                "lastN": 1
            },
            {
                "name": "This_shift",
                "description": "This_shiftD",
                "tfId": "thisWorkShift",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "workShiftsID",
                "periodMode": "thisID",
                "lastN": 1
            },
            {
                "name": "Shift_to_now",
                "description": "Shift_to_nowD",
                "tfId": "workShiftToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "workShiftsID",
                "periodMode": "toNowID",
                "lastN": 1
            },
            {
                "name": "This_workDay",
                "description": "This_workDayD",
                "tfId": "thisWorkDay",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "workDaysID",
                "periodMode": "thisID",
                "lastN": 1
            },
            {
                "name": "WorkDay_to_now",
                "description": "WorkDay_to_nowD",
                "tfId": "workDayToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "workDaysID",
                "periodMode": "toNowID",
                "lastN": 1
            },
            {
                "name": "This_workWeek",
                "description": "This_workWeekD",
                "tfId": "thisWorkWeek",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "workWeeksID",
                "periodMode": "thisID",
                "lastN": 1
            },
            {
                "name": "WorkWeek_to_now",
                "description": "WorkWeek_to_nowD",
                "tfId": "workWeekToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "workWeeksID",
                "periodMode": "toNowID",
                "lastN": 1
            }
        ]
        return Promise.all(TTTrad).then(tradArray => {
            let pName = Object.getOwnPropertyNames(TT);
            Object.getOwnPropertyNames(TT).forEach((x, index) => {
                TT[x] = tradArray[pName.indexOf(x)]
            });
            const tfT = tf.map(tf => {
                tf.name = TT[tf.name];
                tf.description = TT[tf.description];
                return tf;
            })
            _appCtxSvc.updateCtx("OpcenterDashboardbComposerTimeframes", tfT);
            _appCtxSvc.updateCtx("defaultOpcenterDashboardbComposerTimeframes", JSON.parse(JSON.stringify(tfT)));
        })
    }
    return Promise.resolve();
}
exports.oPINRuntimeQCSublocationPrereq = function () {
    if (!checkFeatures()){
        //momUtils.navigateTo("missingPage",null)
        alert("AssetPerformance feature not available")
        return Promise.reject("AssetPerformance feature not available")
    }
    console.debug("###Prereq Enter oPINRuntimeQCSublocationPrereq")
    changePrereqStatus(1);

    //Navigation service prereq
    const navParsList = _appCtxSvc.getCtx("navParsList");
    if (navParsList === null || navParsList === undefined) {
        _appCtxSvc.updateCtx("navParsList", [{
                Id: 1,
                Name: "siteKey",
                Description: "Navigation site Key/Unique Identifier",
                Types: ['siteKey', 'string'],
                builtIn: true,
                paramName: "siteKey",
                DefaultValue: null
            },
            {
                Id: 2,
                Name: "assetKey",
                Description: "Navigation asset Key",
                Types: ["assetKey", "string"],
                builtIn: true,
                paramName: "assetKey",
                DefaultValue: null
            },
            {
                Id: 3,
                Name: "assetUID",
                Description: "Navigation asset Unique Identifier",
                Types: ['assetUID', 'object'],
                builtIn: true,
                paramName: "assetUID",
                DefaultValue: null
            }
        ]);
    }
    oPINRQCNavigationParamService.getCurrentNavParams(); //ensure navigation start

    const p1 = Promise.resolve();
    const p2 = moveTimeFrameToCtx().then(res => { 
        buildvalipPageTemplate()
    });
    const TT = {
        "searchByName": "oPINRuntimeModuleMessage"
    };
    const usersDisplayName = _appCtxSvc.getCtx("usersDisplayName");
    let p4 = Promise.resolve();
    if (!usersDisplayName){
        p4 =oPINRQCService.getUsers(); //init usersDisplayName context for dashboards table
    }
    const p3 = localeService.getLocalizedText("oPINRuntimeModuleMessage", "searchByName")
    return Promise.all([p1,p2,p3,p4]).then(x => {
        _appCtxSvc.updateCtx("opINSearchByNameTrad",p3)
        changePrereqStatus(-1);
        console.debug("###Prereq Exit oPINRuntimeQCSublocationPrereq");
    })
}
exports.oPINRuntimeQCDashboardSourcesPrereq = function () {
    console.debug("###Prereq Enter oPINRuntimeQCDashboardSourcesPrereq")
    changePrereqStatus(1);
    let MPDashboardContributor = _appCtxSvc.getCtx("oPINProjectsConfig").oPINRuntime.MPDashboardContributor;
    const chekQCE = _appCtxSvc.getCtx("oPINProjectsConfig").hasOwnProperty("enableQCEditor") ?_appCtxSvc.getCtx("oPINProjectsConfig").enableQCEditor:true;
    let p3 = Promise.resolve();
    if (!chekQCE){
        //crack group
        MPDashboardContributor = MPDashboardContributor+"REACTMIGRATIONDISABLE"
        //p3 = Promise.reject();
    }
    const p1 = exports.oPINRuntimeQCSublocationPrereq();
    const p2 = utilService.checkPageAccess(MPDashboardContributor);
    return Promise.all([p1,p2.p3]).then(x => {
        changePrereqStatus(-1);
        console.debug("###Prereq Exit oPINRuntimeQCDashboardSourcesPrereq");
    })
}
exports.oPINRuntimeQCDashboardPubsPrereq = function () {
    console.debug("###Prereq Enter oPINRuntimeQCDashboardPubsPrereq")
    changePrereqStatus(1);
    const MPDashboardContributor = _appCtxSvc.getCtx("oPINProjectsConfig").oPINRuntime.MPDashboardViewer;
    const p1 = exports.oPINRuntimeQCSublocationPrereq();
    const p2 = utilService.checkPageAccess(MPDashboardContributor);
    return Promise.all([p1,p2]).then(x => {
        changePrereqStatus(-1);
        console.debug("###Prereq Exit oPINRuntimeQCDashboardPubsPrereq");
    })
}

exports.oPINNavigationPrereq = function () {
 let url = _appCtxSvc.getCtx("oPINProjectsConfig").oPINRuntime.apiDSComposer+'opdashboard/published/';
    const p1 = utilService.OCINRESTServiceRaw("get",url).then(res => { 
    _appCtxSvc.updateCtx("publishedDSBlob",res.data.Body);
    _appCtxSvc.registerCtx("publishedDSObj");
    _appCtxSvc.updateCtx("navTreeLinkMode","list");
    });
    return Promise.all([p1])
}

export default exports;